export const DEFAULT_LANGUAGE = "en";
export const GOOGLE_TRACKING_ID = "G-WWNFFK7T9V";
export const HOTJAR_ID = 3240518;
export const HOTJAR_SNIPPET_VERSION = "6";
export const HELLO_SIGN_CLIENT_ID = "ffaf051f453245d4fcf47de34a4de1b0";

// export const SMARTY_EMBEDDED_KEY = "175873552263955307"; // DEV
export const SMARTY_EMBEDDED_KEY = "175873551332593046"; // STAGING
